module.exports = __webpack_public_path__ + "img/block_02_img.c652345b.png";